import {
  formatPounds,
  formatThresholdPounds,
  LQG_THRESHOLD_HAZARDOUS_KG,
  poundsExceed,
  SQG_THRESHOLD_HAZARDOUS_KG,
  thresholdPounds,
} from "encamp-shared/src/constants/wasteGeneratorStatusThresholds";

function describeGap(amountLb: number, tier: "SQG" | "LQG", thresholdKg: number): string {
  const thresholdLb = thresholdPounds(thresholdKg);
  const line = `fed ${tier} threshold of ${thresholdKg.toLocaleString("en-US")} kg (${formatThresholdPounds(thresholdKg)} lbs)`;
  const gap = formatPounds(Math.abs(amountLb - thresholdLb));
  if (gap === "0") return `At the ${line}`;
  return `${gap} lbs ${amountLb > thresholdLb ? "above" : "below"} the ${line}`;
}

/**
 * How far a month's federal total sits from the next line that could move its
 * tier: SQG until the total exceeds 100 kg, LQG after. Uses the federal
 * calculator's kg rule, so a gap that rounds to nothing reads "At".
 */
export function federalThresholdComparison(amountLb: number): string {
  return poundsExceed(amountLb, SQG_THRESHOLD_HAZARDOUS_KG)
    ? describeGap(amountLb, "LQG", LQG_THRESHOLD_HAZARDOUS_KG)
    : describeGap(amountLb, "SQG", SQG_THRESHOLD_HAZARDOUS_KG);
}
